import { NumberFormatterAdapter } from "@/infrastructure/adapters/number";
import { NumberFormatType } from "../types";

export class NumberFormatterService {
  constructor(private readonly numberFormatterAdapter: NumberFormatterAdapter) {}

  formatAsInteger(value: number): string {
    return this.numberFormatterAdapter.formatAsInteger(value);
  }

  formatAsTwoDecimal(value: number): string {
    return this.numberFormatterAdapter.formatAsTwoDecimal(value);
  }

  formatAsAccounting(value: number): string {
    return this.numberFormatterAdapter.formatAsAccounting(value);
  }

  format(value: number, format: NumberFormatType): string {
    if (format === "integer") {
      return this.formatAsInteger(value);
    } else if (format === "twoDecimal") {
      return this.formatAsTwoDecimal(value);
    } else if (format === "accounting") {
      return this.formatAsAccounting(value);
    }
    return this.formatAsTwoDecimal(value);
  }
}
